import React, { useCallback } from 'react';
import { Checkbox } from 'antd';
import { FormikValues, useField, useFormikContext } from 'formik';
import { CheckboxProps, CheckboxChangeEvent } from 'antd/lib/checkbox';
import { useFormikFormContext } from '../FormikFormContext';
import { IExtraInputProps, useInputProps } from '../hooks/useInputProps';

export interface CheckboxInputProps<T extends FormikValues>
  extends Omit<CheckboxProps, 'name'>,
    IExtraInputProps {
  name: keyof T & string;
}

/**
 * Campo per input di tipo checkbox.
 */
export function CheckboxInput<T extends FormikValues>(
  props: CheckboxInputProps<T>
) {
  const { name, extraOptions, ...otherProps } = props;
  const [field, meta] = useField<boolean>(name);
  const formik = useFormikContext<T>();
  const inputProps = useInputProps(props);
  const handleChange = useCallback(
    (e: CheckboxChangeEvent) => formik.setFieldValue(name, e.target.checked),
    [name]
  );

  return (
    <Checkbox
      {...otherProps}
      {...field}
      checked={field.value}
      onChange={handleChange}
      {...inputProps}
    />
  );
}
